function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 29H9V32H10.5H12V33.5V35H15V33.5V32L28.5 32C30.433 32 32 30.433 32 28.5V15H33.5H35V12H33.5H32V10.5V9H29V10.5V12H15.5C13.567 12 12 13.567 12 15.5V29H10.5ZM15 29L28.5 29C28.7761 29 29 28.7761 29 28.5V15H15.5C15.2239 15 15 15.2239 15 15.5V29Z",
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 19,
  width: 6,
  height: 6,
  rx: 1,
  fill: "currentcolor"
});

var SvgCropRotate = function SvgCropRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCropRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crop-rotate.95bec244.svg";
export { ForwardRef as ReactComponent };